import { SelectDropDown } from '@wot/components';
import { ROWS_PER_PAGE } from '../utils/constants';

interface Props {
  count: number;
  currentPage: number;
  resultsPerPage: number;
  prevPage: any;
  nextPage: any;
  setResultsPerPage: any;
}

export default function Pagination({
  count,
  currentPage,
  nextPage,
  prevPage,
  resultsPerPage,
  setResultsPerPage
}: Props) {
  return (
    <div className="flex my-3 items-center justify-between py-2 px-2 bg-white">
      <p className="text-sm font-semibold">{count} Results found.</p>
      <div className="flex items-center gap-4">
        <p className="text-sm font-semibold text-ellipsis text-left text-gray-900 whitespace-nowrap">
          {`${Math.ceil(count / resultsPerPage) === 0 ? 0 : currentPage} of ${Math.ceil(count / resultsPerPage)} pages`}
        </p>
        <button
          onClick={() => prevPage()}
          disabled={currentPage === 1}
          className={`border-2 rounded-sm ${
            currentPage === 1 ? 'opacity-40' : 'opacity-100'
          } font-semibold p-2 text-xs flex items-center justify-center`}
        >
          Prev
        </button>
        <div className="min-w-[64px]">
          <SelectDropDown
            size="small"
            onChange={(value) => setResultsPerPage(Number(value))}
            options={ROWS_PER_PAGE}
            placeholder="No Of Rows"
            value={resultsPerPage.toString()}
          />
        </div>
        <button
          onClick={() => nextPage()}
          disabled={currentPage >= Math.ceil(count / resultsPerPage)}
          className={`border-2 rounded-sm ${
            currentPage >= Math.ceil(count / resultsPerPage) ? 'opacity-40' : 'opacity-100'
          } font-semibold  p-2 text-xs flex items-center justify-center`}
        >
          Next
        </button>
      </div>
    </div>
  );
}
